import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'
import modules from './modules'
Vue.use(Vuex);
export default ()=>{
  //使用函数返回 防止内存溢出
  return new Vuex.Store({
    state,
    mutations,
    getters,
    actions,
    modules
  }) 
}  